import { EmptyArray } from 'lib/array/arrayUtils'
import { floatify } from 'lib/maths/mathUtils'

/**
 * Spreads the points the customer chose across the burnable items, in the order the calculation
 * view ranks them, to give one points payment per item.
 */
function buildLoyaltyBurningPointItems(
  pointsToBurn: number | undefined,
  view: App.Checkout.LoyaltyPointBurnCalculationView,
): Array<App.Checkout.LoyaltyBurningPointItem> {
  if (!pointsToBurn) return EmptyArray
  if (view.minBurnablePoints > pointsToBurn) return EmptyArray
  if (view.burnableItems.length === 0) return EmptyArray

  const pointsToBurnPerItem: Array<App.Checkout.LoyaltyBurningPointItem> = []
  let remainingPoints = pointsToBurn
  for (const pointBurnViewItem of view.burnableItems) {
    if (remainingPoints <= 0) break
    const pointsPaid = Math.min(pointBurnViewItem.payablePriceInPoints, remainingPoints)
    const priceInPoints = pointBurnViewItem.actualPriceInPoints
    const priceInCurrency = pointBurnViewItem.actualPriceInCurrency
    const pointsPaidInCurrency = floatify((pointsPaid * priceInCurrency) / priceInPoints)

    // Get orderItemId for post-purchase flows (e.g., BNBL select-date)
    const orderItemId = 'orderItemId' in pointBurnViewItem.itemView.item
      ? pointBurnViewItem.itemView.item.orderItemId
      : undefined

    pointsToBurnPerItem.push({
      priceInCurrency,
      priceInPoints,
      pointsPaid,
      pointsPaidInCurrency,
      mx: pointBurnViewItem.itemView.loyalty.mx ?? pointBurnViewItem.itemView.mx,
      productType: pointBurnViewItem.itemView.loyalty.productType!,
      itemTransactionKey: pointBurnViewItem.itemView.item.transactionKey,
      itemId: pointBurnViewItem.itemView.item.itemId,
      orderItemId,
    })
    remainingPoints -= pointsPaid
  }

  if (!pointsToBurnPerItem.length) return EmptyArray

  return pointsToBurnPerItem
}

export default buildLoyaltyBurningPointItems
